import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { ValidatorPattern } from '../utility/validators.pattern';

@Directive({
  selector: '[appDigitWithTwoDecimalNumber]',
})
export class AppDigitWithTwoDecimalNumberDirective {
  @Input() appDigitWithTwoDecimalNumber!: number;
  public regexPattern!: RegExp;

  private readonly specialKeys: Array<string> = [
    'Backspace',
    'Tab',
    'End',
    'Home',
  ];

  constructor(private readonly el: ElementRef) {}

  private setRegexPattern() {
    if (this.appDigitWithTwoDecimalNumber === 7) {
      this.regexPattern = new RegExp(ValidatorPattern.SevenDigitTwoDecimal);
    } else if (this.appDigitWithTwoDecimalNumber === 17) {
      this.regexPattern = new RegExp(ValidatorPattern.SeventeenDigitTwoDecimal);
    } else if (this.appDigitWithTwoDecimalNumber === 2) {
      this.regexPattern = new RegExp(ValidatorPattern.TwoDigitTwoDecimal);
    } else if (this.appDigitWithTwoDecimalNumber === 4) {
      this.regexPattern = new RegExp(ValidatorPattern.FourDigitThreeDecimal);
    } else if (this.appDigitWithTwoDecimalNumber === 9) {
      this.regexPattern = new RegExp(ValidatorPattern.NineDigitThreeDecimal);
    } else if (this.appDigitWithTwoDecimalNumber === 10) {
      this.regexPattern = new RegExp(ValidatorPattern.TenDigitTwoDecimal); // ✅ Add support for 10
    } else if (this.appDigitWithTwoDecimalNumber === 126) {
      this.regexPattern = new RegExp(
        ValidatorPattern.OneHundredTwentySixCharTwoDecimal
      );
    }
  }

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    this.setRegexPattern();

    const current: string = this.el.nativeElement.value;
    const next: string = current.concat(event.key);

    if (this.isSpecialKey(event.key)) {
      return;
    }

    if (this.isMinusSign(event.key)) {
      event.preventDefault();
      return;
    }

    if (this.isInvalidDotOrZeroPosition(next)) {
      event.preventDefault();
    }

    if (this.exceedsMaxLength(next)) {
      event.preventDefault();
    }

    if (!this.matchesRegexPattern(next)) {
      event.preventDefault();
    }
  }

  private isSpecialKey(key: string): boolean {
    return this.specialKeys.includes(key);
  }

  private isMinusSign(key: string): boolean {
    return key === '-';
  }

  private isInvalidDotOrZeroPosition(next: string): boolean {
    const checkDotFirstPosition: string = next.substring(0, 1);
    const checkSecondPosition: string = next.substring(0, 2);

    return (
      checkDotFirstPosition === '.' ||
      (next.length > 1 &&
        checkDotFirstPosition === '0' &&
        checkSecondPosition !== '0.')
    );
  }

  private exceedsMaxLength(next: string): boolean {
    const maxLength = this.appDigitWithTwoDecimalNumber;
    const digitsBeforeDecimal = next.split('.')[0].replace('-', '').length;
    if (digitsBeforeDecimal <= maxLength) {
      return false;
    }
    return (
      !next.includes('.') ||
      next.split('.')[0].replace('-', '').length > maxLength
    );
  }

  private matchesRegexPattern(testValue: string): boolean {
    if (this.regexPattern.exec(testValue)) {
      return true;
    }
    return false;
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    this.setRegexPattern();

    const pastedInput: string = event.clipboardData?.getData('text') ?? '';
    const current: string = this.el.nativeElement.value;
    const combined = current + pastedInput;

    if (!this.regexPattern.exec(combined)) {
      event.preventDefault();
    }
  }
}
